import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHouse4 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#house-4_svg__a)'>
      <path
        stroke='#fff'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M14 20h3a2 2 0 0 0 2-2V9.332a2 2 0 0 0-.971-1.715L12 4 5.971 7.617A2 2 0 0 0 5 9.332V18a2 2 0 0 0 2 2h3'
      />
      <path
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='m2 10 10-6 10 6'
      />
      <path
        fill='#fff'
        d='M19 9.332V18a2 2 0 0 1-2 2h-3v-5a2 2 0 1 0-4 0v5H7a2 2 0 0 1-2-2V9.332a2 2 0 0 1 .971-1.715L12 4l6.029 3.617A2 2 0 0 1 19 9.332'
        opacity={0.2}
      />
      <path
        stroke='#fff'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M10 21v-7a2 2 0 1 1 4 0v7'
      />
    </g>
    <defs>
      <clipPath id='house-4_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgHouse4)
export default ForwardRef
